import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "selected", "onSelectedChange", "isHeader"];
import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { TableHeaderCell } from './elements/TableHeaderCell';
import { TableCell } from './elements/TableCell';
import { TableRow } from './elements/TableRow';
import { ControllableNext as Controllable } from '../Controllable/ControllableNext';
import { Checkbox } from '../Checkbox/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectableTableRowComponent = _ref => {
  let {
      children,
      selected,
      onSelectedChange,
      isHeader
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Wrapper = isHeader ? TableHeaderCell : TableCell;
  const handleClick = useCallback(() => {
    if (onSelectedChange) onSelectedChange(syntheticEvent(!selected));
  }, [onSelectedChange, selected]);
  return /*#__PURE__*/_jsxs(TableRow, Object.assign({
    selected: selected
  }, rest, {
    children: [/*#__PURE__*/_jsx(Wrapper, {
      inlineSize: "60px",
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": unescapedText('salesUI.UITable.selectableTableRow.toggleSelection'),
        onChange: handleClick,
        checked: selected
      })
    }), children]
  }));
};
export const SelectableTableRow = Controllable(SelectableTableRowComponent, ['selected']);